var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 124,
    viewBox: "0 0 129 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 125,
    height: 120,
    rx: 10,
    fill: "white",
    stroke: "#459AA4",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_387_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5742 88.3119V40.0735C42.5742 37.7474 43.4983 35.5165 45.1431 33.8717C46.7879 32.2269 49.0187 31.3029 51.3448 31.3029H53.5375C54.119 31.3029 54.6767 31.0718 55.0879 30.6606C55.4991 30.2494 55.7302 29.6917 55.7302 29.1102C55.7302 28.5287 55.9612 27.971 56.3724 27.5598C56.7836 27.1486 57.3413 26.9175 57.9228 26.9175H71.0787C71.6603 26.9175 72.218 27.1486 72.6292 27.5598C73.0404 27.971 73.2714 28.5287 73.2714 29.1102C73.2714 29.6917 73.5024 30.2494 73.9136 30.6606C74.3248 31.0718 74.8825 31.3029 75.464 31.3029H77.6567C79.9828 31.3029 82.2137 32.2269 83.8585 33.8717C85.5033 35.5165 86.4273 37.7474 86.4273 40.0735V88.3119C86.4273 90.638 85.5033 92.8688 83.8585 94.5136C82.2137 96.1585 79.9828 97.0825 77.6567 97.0825H51.3448C49.0187 97.0825 46.7879 96.1585 45.1431 94.5136C43.4983 92.8688 42.5742 90.638 42.5742 88.3119Z",
    stroke: "#459AA4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5371 89.79H79.2835",
    stroke: "#459AA4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5371 82.6947H79.2835",
    stroke: "#459AA4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2847 59.6386C52.0237 59.6396 51.7677 59.5637 51.5466 59.42C51.3254 59.2762 51.1482 59.0704 51.0355 58.8265C50.9228 58.5826 50.8793 58.3106 50.9099 58.042C50.9406 57.7735 51.0441 57.5195 51.2086 57.3095L64.8671 42.7345C64.9696 42.612 65.1092 42.5292 65.2631 42.4998C65.4169 42.4703 65.5759 42.4959 65.7139 42.5723C65.8518 42.6488 65.9606 42.7715 66.0224 42.9204C66.0841 43.0693 66.0951 43.2355 66.0536 43.3918L63.4047 51.9939C63.3266 52.2104 63.3004 52.4433 63.3283 52.6726C63.3562 52.902 63.4373 53.1209 63.5649 53.3105C63.6924 53.5002 63.8624 53.655 64.0604 53.7617C64.2584 53.8684 64.4784 53.9237 64.7016 53.9229H74.3591C74.6202 53.922 74.8762 53.9978 75.0973 54.1416C75.3184 54.2854 75.4956 54.4911 75.6083 54.7351C75.721 54.979 75.7646 55.251 75.7339 55.5195C75.7033 55.7881 75.5997 56.0421 75.4352 56.2521L61.7767 70.8271C61.6743 70.9496 61.5346 71.0323 61.3808 71.0618C61.2269 71.0913 61.068 71.0657 60.93 70.9893C60.792 70.9128 60.6832 70.7901 60.6215 70.6412C60.5598 70.4923 60.5487 70.326 60.5902 70.1698L63.2391 61.5677C63.3173 61.3512 63.3435 61.1182 63.3156 60.8889C63.2877 60.6596 63.2065 60.4407 63.079 60.251C62.9515 60.0613 62.7814 59.9065 62.5834 59.7999C62.3855 59.6932 62.1654 59.6379 61.9423 59.6386H52.2847Z",
    stroke: "#459AA4",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_387_56"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.877,
    y: 9.37628,
    width: 105.247,
    height: 105.247,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEms);
export default __webpack_public_path__ + "static/media/Ems.84b5aadfff67cf8ff22fc11bf7be6adc.svg";
export { ForwardRef as ReactComponent };